import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators  } from '@angular/forms';
import { CommonService } from '../../../services/common/common.service';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { LandingpageService } from '../../../services/landingpage/landingpage.service';
import { BaseService } from 'src/app/modules/base/base.service';
import { ProductMatrixService } from "../../../services/product-matrix/product-matrix.service";

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.scss']
})
export class CreateCategoryComponent implements OnInit {

  
    @Input() apiData: any = [];
    @Input() actionInfo: any = [];
    @Output() emitResponse: EventEmitter<any> = new EventEmitter();
   
    changePasswordForm: UntypedFormGroup;
    public invalidOldPwdMsg: string = "";
    public invalidMsgFlag = false;
    public strlengthforuser:string ='0';
    public NewCategoryNumberLenth:string ='50';
    public enterTxt: string = "Enter";
    public textcategoryName: string = "Category Name";
    public cpFormData = new FormData();
    public submitLoading: boolean = false;
    public submitFlag: boolean = false;
    public invalidMsg: String = "";
    public opwdFieldTextType: boolean = false;
    public npwdFieldTextType: boolean = false;
    public cpwdFieldTextType: boolean = false;
    public changPasswordSubmitted: boolean = false;
    public countryId;
    public actionWSID: any = [];
    public allSelection: any;
    public emitData = {
      action: true,
      categoryAction: '',
      deleteStatus: '',
      msg: '',
      name: '',
      fid: '',
      wslist: [],
      refresh: '0'
    };
    public action;
    public actionId;
    public actionName;
    public categoryName;
    public deleteCategoryFlag: boolean = false;
    public checkboxFlag1: boolean = false;
    public checkboxFlag2: boolean = false;
    public noFilesFlag: boolean = false;

    public workstreamItems: any = [];
    public workstreamId: any = [];
    public workstreamIdOriginal: any = [];
    public workstreamSelection: any = [];
    public workstreamValid: boolean = true;
    public defaultWSLabel: string = 'Select Workstream';
    public workstreamUpdate: boolean = false;
    public workstreamEdit: boolean = false;
    public workstreamDelete: boolean = false;
    public workstreamDeleteArr: any = [];
    public allworkstreamToggle: boolean = false;
    public toggleOptionShow: boolean = false;
    public showAllWS: boolean = true;
  
    constructor(
  
      private landingpageAPI: LandingpageService,
      private formBuilder: UntypedFormBuilder,
      private commonApi: CommonService,
      private authApi: AuthenticationService,
      private baseSerivce: BaseService,
      private ProductMatrixApi: ProductMatrixService,

    ) { 
  
  
      
    }
    get c() { return this.changePasswordForm.controls; }
    ngOnInit(): void {
  
      this.action = this.actionInfo['action'];
      if(this.actionInfo['action'] == 'delete' ){
        this.deleteCategoryFlag = true;
        this.checkboxFlag2 = true;
        if(this.actionInfo['count'] == 0){
          this.noFilesFlag = true;
        }
      }
      this.actionId = this.actionInfo['id'];
      this.actionName = this.actionInfo['name'];
      console.log(this.actionInfo)
  
      if(this.action == 'edit'){
        this.categoryName = this.actionName;
        this.strlengthforuser = this.categoryName.length;
        this.workstreamId  = this.actionWSID;
        this.workstreamIdOriginal = this.actionWSID;
      }
      else{
        this.categoryName = '';
        this.workstreamId = '';
      }
  
      if(!this.deleteCategoryFlag){
        this.changePasswordForm = this.formBuilder.group({
          categoryName: [this.categoryName, [Validators.required]],
          wsFormControl: [this.workstreamId, []],
        },
        {
          // check whether our password and confirm password match
          
        }); 
     }
      this.countryId = localStorage.getItem('countryId');
      this.getWorkstreamLists();
    }

      // Get Workstream Lists
  getWorkstreamLists() {
    let type: any = 1;
    const apiFormData = new FormData();
    apiFormData.append('apiKey', this.apiData['apiKey']);
    apiFormData.append('userId', this.apiData['userId']);
    apiFormData.append('domainId', this.apiData['domainId']);
    apiFormData.append('countryId', this.countryId);
    apiFormData.append("type", type);

    this.ProductMatrixApi.getWorkstreamLists(apiFormData).subscribe(
      (response) => {
        let resultData = response.workstreamList;

        //let alls = {id: "0", name: "All"};
        let data = response.allSelection != undefined ? response.allSelection : '';

        this.allSelection = this.showAllWS  ? data : '';

        this.workstreamItems= [];
        for (let ws of resultData) {
          this.workstreamItems.push({
            id: ws.id,
            name: ws.name,
          });
        }
        if(this.allSelection!=''){
          this.workstreamItems.unshift(this.allSelection);
        }
        if(this.action == 'edit'){
          let wsIndex;
          this.workstreamId = localStorage.getItem('workstreamsList')!= null ? JSON.parse(localStorage.getItem('workstreamsList')) : [];
          console.log(this.workstreamId)
          if(this.workstreamId && this.workstreamId.length>0){
          wsIndex = this.workstreamId.findIndex(option => option == '0');
          }
          this.changePasswordForm.get('wsFormControl').reset();
          this.workstreamSelection = [];
          if(wsIndex!='0' && this.workstreamId){
            for(let ws of this.workstreamItems) {
              for(let wss of this.workstreamId ) {
                if(ws.id == wss){
                  this.workstreamSelection.push({
                    id: ws.id,
                    name: ws.name,
                  });
                }
              }
            }
          }
          else{
            if(this.workstreamId && this.workstreamId.length>0){
              if(this.workstreamItems.length == this.workstreamId.length || wsIndex == '0'){
                for(let ws of this.workstreamItems) {
                  this.workstreamId.push(ws.id);
                }
                if(this.allSelection!=''){
                  this.workstreamSelection.unshift(this.allSelection);
                }
              }
            }
          }
          this.changePasswordForm.get('wsFormControl').patchValue(this.workstreamId);
          if(this.workstreamSelection.length>0){
            this.workstreamValid = false;
          }
          else{
            this.workstreamValid = true;
          }
        }
        else{
          this.workstreamId = [];
          this.workstreamSelection = [];
        }
      }
    );
  }
  
    actionSubmit() {
      console.log();
      if(this.submitLoading || !this.submitFlag || this.workstreamValid)
        return false;
       
      this.changPasswordSubmitted = true;
      let invalidFlag = true;
      let opwd = this.changePasswordForm.value.categoryName;     
  
      let wsid = [];
      wsid = this.workstreamId;
      let wsidArry = '';
      if(this.workstreamId.length>0){
        wsidArry = JSON.stringify(this.workstreamId);
      }
      let dwsidArry = '';

      if(this.action == 'edit'){
        if(localStorage.getItem('workstreamsList') != null && localStorage.getItem('workstreamsList') != 'null'){
          ///remove once workstreams came
          let arr1 = JSON.parse(localStorage.getItem('workstreamsList'));
          let arr2 = this.workstreamId
          let difference = arr1.filter(x => !arr2.includes(x));
          console.log(difference);
    
          let arr11 = JSON.parse(localStorage.getItem('workstreamsList'));
          let arr21 = this.workstreamId
          let difference11 = arr21.filter(x => !arr11.includes(x));
          console.log(difference11);
    
          this.workstreamDeleteArr = difference;
          if(difference.length>0 || difference11.length>0){
            this.workstreamUpdate = true;
          }
          if(this.workstreamDeleteArr.length>0){
            dwsidArry = JSON.stringify(this.workstreamDeleteArr);
          }
        }
      }
      console.log("Add Array"+wsidArry);
      console.log("delete Array"+dwsidArry);

      this.submitLoading = true;
      this.cpFormData = new FormData();
      this.cpFormData.append('apiKey', this.apiData['apiKey']);
      this.cpFormData.append('userId', this.apiData['userId']);
      this.cpFormData.append('domainId', this.apiData['domainId']);
      this.cpFormData.append('countryId', this.countryId);
      this.cpFormData.append('categoryName', opwd.trim());
      this.cpFormData.append('workstreams', wsidArry);
      if(this.actionInfo['action'] == 'edit'){
        this.cpFormData.append('categoryId', this.actionId);
        this.cpFormData.append('oldCategoryName',this.actionName.trim());
      }       
      if(this.workstreamUpdate && this.action == 'edit'){
        this.cpFormData.append('workstreamUpdate',"1");
      }
      if(this.workstreamDeleteArr.length>0 && this.action == 'edit'){
        this.cpFormData.append('removedWorkstreams',dwsidArry);
      }

      let callAbleUrl = this.authApi.apiSaveCategoryFolder(this.cpFormData);
      if (this.apiData['pageType'] == 'parts') {
        callAbleUrl = this.authApi.apiSavePartCategoryFolder(this.cpFormData);
      }

        callAbleUrl.subscribe((response) => {
        console.log(response)
        let msg = response.result;
        let msgData = response.data;
        if(response.status == 'Success') {

          const apiData = new FormData();
          apiData.append('apiKey', this.apiData['apiKey']);
          apiData.append('domainId', this.apiData['domainId']);
          //apiData.append('dataId', this.actionId);
          apiData.append('userId', this.apiData['userId']);
          let type = (this.apiData['pageType'] == 'parts') ? '4' : '6';
          apiData.append('actionType', type);
          apiData.append('platform', '3');

          if(this.actionInfo['action'] == 'edit'){
            apiData.append('dataId', response.dataId);
            apiData.append('action', 'folderUpdate');
          }
          else{
            apiData.append('action', 'create'); 
            apiData.append('threadId', response.documentId);
          }

          this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiData).subscribe((response: any) => { })
  
          if(this.action != 'edit' && this.action != 'delete'){
            if(this.workstreamId.length>0){
              localStorage.setItem('workstreamsList',wsidArry);
            }
          }

          if(msgData=='2')
          {
            this.submitLoading = false;
         
           
            this.invalidOldPwdMsg = msg;
          }
          else
          {
            this.invalidMsgFlag = false;
            this.invalidMsg = "";
            this.emitData.msg = msg;
            this.emitData.name = opwd;
            this.emitData.wslist = wsid;
            if(this.actionInfo['action'] == 'edit'){
              this.emitData.fid=response.dataId;
            }
            else{
              this.emitData.fid=response.documentId;
            }
            if(this.workstreamEdit){
              this.emitData.refresh = "1";
            }
            this.emitData.deleteStatus = '';
            this.emitData.categoryAction = this.actionInfo['action'];

            //this.emitData.msg = `<div class="msg-row-1 text-center">${msg}<p>Please login again</p></div>`;
            this.emitResponse.emit(this.emitData);
            setTimeout(() => {
           // this.requestPermission(0);
         
           // this.authApi.logout();
            },1000);
  
          }
  
         
        } else {
          this.submitLoading = false;
         
           
            this.invalidOldPwdMsg = msg;
          
        }
      });
    }
  
    actionDelete() {
      if(this.submitLoading)
        return false;
  
      let deleteStatus = this.checkboxFlag2 ? '2' : '1';
      this.emitData.categoryAction = this.action;
      this.emitData.deleteStatus = deleteStatus;
      
      this.submitLoading = true;
      this.cpFormData = new FormData();
      this.cpFormData.append('apiKey', this.apiData['apiKey']);
      this.cpFormData.append('userId', this.apiData['userId']);
      this.cpFormData.append('domainId', this.apiData['domainId']);
      this.cpFormData.append('countryId', this.countryId);
      this.cpFormData.append('categoryId', this.actionId);
      this.cpFormData.append('categoryName',this.actionName.trim());    
      this.cpFormData.append('deleteStatus',deleteStatus);   
      
      let callAbleUrl = this.authApi.apiSaveCategoryFolder(this.cpFormData);
      if (this.apiData['pageType'] == 'parts') {
        callAbleUrl = this.authApi.apiSavePartCategoryFolder(this.cpFormData);
      }

        callAbleUrl.subscribe((response) => {
     
      //this.authApi.apiSaveCategoryFolder(this.cpFormData).subscribe((response) => {
        console.log(response)
        let msg = response.result;
        let msgData = response.data;
        
        if(response.status == 'Success') {

          if(deleteStatus == '1'){
            const apiData = new FormData();
            apiData.append('apiKey', this.apiData['apiKey']);
            apiData.append('domainId', this.apiData['domainId']);
            apiData.append('dataId', this.actionId);
            apiData.append('userId', this.apiData['userId']);
            let deleteIds = response.modelResultDocs;
            apiData.append('modelResultDocs', JSON.stringify(deleteIds));
            apiData.append('isGeneral', '1');
            apiData.append('action', 'categoryUpdate');
            let type = (this.apiData['pageType'] == 'parts') ? '4' : '6';
            apiData.append('actionType', type);
            apiData.append('platform', '3');
            this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiData).subscribe((response: any) => { })
            }
          if(deleteStatus == '2'){
            const apiData = new FormData();
            apiData.append('apiKey', this.apiData['apiKey']);
            apiData.append('domainId', this.apiData['domainId']);
            apiData.append('dataId', this.actionId);
            apiData.append('userId', this.apiData['userId']);
            apiData.append('action', 'categoryDelete');
            let type = (this.apiData['pageType'] == 'parts') ? '4' : '6';
            apiData.append('actionType', type);
            apiData.append('platform', '3');
            this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiData).subscribe((response: any) => { })
         
          }

          if(msgData=='2')
          {
            this.submitLoading = false;
            this.invalidOldPwdMsg = msg;
          }
          else
          {
            this.invalidMsgFlag = false;
            this.invalidMsg = "";
            this.emitData.msg = msg;          
            this.emitResponse.emit(this.emitData);
            setTimeout(() => {
              // this.requestPermission(0);
              // this.authApi.logout();
            },1000);
          }
        } else {
          this.submitLoading = false;
          this.invalidOldPwdMsg = msg;
        }
      });
    }
  
    categorycreatevalidate(event)
    {
      let val = event.target.value.trim();
      if(val.length>0)
      {
        this.invalidOldPwdMsg="";
        this.changPasswordSubmitted = true;
        this.strlengthforuser=event.target.value.length;
        this.submitFlag = true;  
        if(this.workstreamId.length>0 || this.allworkstreamToggle){
          this.workstreamValid = false;
        }
      }
      else
      {
        this.submitFlag = false;  
        this.strlengthforuser='0';
        this.changPasswordSubmitted = false;
      }
    }
   
    cancelAction() {

      if(this.action == 'edit'){

        this.actionId = this.actionInfo['id'];
        this.actionName = this.actionInfo['name'];
  
        this.categoryName = this.actionName;
        this.strlengthforuser = this.categoryName.length;
        this.workstreamId  = this.workstreamIdOriginal;
        this.workstreamIdOriginal = this.workstreamIdOriginal;
  
        this.emitData.name = this.categoryName;
        this.emitData.wslist = this.actionWSID;
  
        this.emitData.action = false;
        this.emitData.categoryAction = 'cancel';
        this.emitData.deleteStatus = '';
  
        this.emitResponse.emit(this.emitData);
      }
      else{
        if(this.submitLoading)
          return false;
    
        this.emitData.action = false;
        this.emitData.categoryAction = 'cancel';
        this.emitData.deleteStatus = '';
        this.emitResponse.emit(this.emitData);
      }
    }
    //
    selectedItems(event){ console.log(event)
      let arr = event.value;
      let uniqueArr = [];
      for(let i of arr) {
        if(uniqueArr.indexOf(i) === -1) {
            uniqueArr.push(i);
        }
      }
      console.log(uniqueArr);
      event.value = uniqueArr;
      this.workstreamId = [];
      this.workstreamSelection = [];
  
      if(event.itemValue == '0'){
        const index = event.value.indexOf(event.itemValue);
        console.log(index);
        if (index > -1 ){
          for(let ws of this.workstreamItems) {
            this.workstreamId.push(ws.id);
          }
          if(this.allSelection!=''){
            this.workstreamSelection.unshift(this.allSelection);
          }
        }
        else{
          this.workstreamId = [];
          this.workstreamSelection = [];
        }
      }
      else{ console.log(event.itemValue);
        if(event.itemValue == undefined){
          this.workstreamId = event.value;
          if(this.workstreamId.length>0){
            if(this.allSelection!=''){
              this.workstreamSelection.unshift(this.allSelection);
            }
          }
          else{
            this.workstreamId = [];
            this.workstreamSelection = [];
          }
        }
        else{
          this.workstreamId = event.value;
          const index = event.value.indexOf('0');
          if (index > -1) {
            this.workstreamId.splice(index, 1);
          }
          for(let ws of this.workstreamItems) {
            for(let wss of this.workstreamId ) {
              if(ws.id == wss){
                this.workstreamSelection.push({
                  id: ws.id,
                  name: ws.name,
                });
              }
            }
          }
        }
      }
      setTimeout(() => {
        this.changePasswordForm.get('wsFormControl').patchValue(this.workstreamId);
      }, 1);
      if(this.workstreamSelection.length>0){
        this.workstreamEdit = true;
        this.workstreamValid = false;
        if(this.changePasswordForm.value.categoryName!=''){
          this.submitFlag = true;
        }
      }
      else{
        this.workstreamValid = true;
      }
  
    }
      // Disable Workstreams Selection
  disableWSSelection(id){
    this.workstreamDelete = true;
    this.workstreamEdit = true;
    for (let wss in this.workstreamSelection ) {
      if(id == this.workstreamSelection[wss].id){
        if(this.workstreamSelection[wss].id == '0'){
          this.workstreamSelection = [];
          this.workstreamId = [];
        }
        else{
          this.workstreamSelection.splice(wss, 1);
        }
      }
    }
    const index1 = this.workstreamId.indexOf(id);
    if (index1 > -1) {
      this.workstreamId.splice(index1, 1);
    }
    setTimeout(() => {
      this.changePasswordForm.get('wsFormControl').patchValue(this.workstreamId);
    }, 1);
    if(this.workstreamSelection.length>0){
      this.workstreamValid = false;
      if(this.changePasswordForm.value.categoryName.length>0){
        this.submitFlag = true;
      }
    }
    else{
      this.workstreamValid = true;
    }
  }

  onChangeAll(event) {
    this.workstreamSelection = [];
    this.changePasswordForm.get('wsFormControl').reset();
    if (event.checked) {
      this.allworkstreamToggle = true;
    }
    else {
      this.allworkstreamToggle = false;
    }
    if(this.workstreamId.length>0 || this.allworkstreamToggle){
      this.workstreamValid = false;
      if(this.changePasswordForm.value.categoryName.length>0){
        this.submitFlag = true;
      }
    }
    else{
      this.workstreamValid = true;
    }
  }

    checkboxChange(flag, type){    
      if(type == 'type1'){
        this.checkboxFlag1 = flag ? false : true;  
        this.checkboxFlag2 =  this.checkboxFlag1 ? false : true;
      }
      else{
        this.checkboxFlag2 = flag ? false : true;  
        this.checkboxFlag1 =  this.checkboxFlag2 ? false : true;    
      }    
    }
  
  }
  